/**
 * Substituição CLIENT-SIDE das variáveis de mensagem ao inserir uma mensagem
 * pronta no composer: o operador vê "Olá Vinicius..." no input ANTES de
 * enviar, já editável (pedido myCar 08/08).
 *
 * O que o navegador sabe resolve aqui: nome do contato da conversa aberta,
 * saudação/data/hora e o nome do operador logado. O que depende do banco
 * ({{campo:X}}, {{responsavel}} quando não passado) fica intacto — o backend
 * resolve no envio (services/message_variables.py), então nada quebra.
 */

const looksLikePhone = (s) => !!s && /^[\d\s()+-]+$/.test(s);

const saudacao = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Bom dia';
  if (h < 18) return 'Boa tarde';
  return 'Boa noite';
};

const tidy = (text) =>
  text
    .replace(/[ \t]+([,!?.;:])/g, '$1')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/[ \t]+$/gm, '');

/**
 * @param {string} text
 * @param {{contactName?: string, operatorName?: string, phone?: string}} ctx
 */
export function renderVariablesInText(text, ctx = {}) {
  if (!text || (!text.includes('{{') && !/\[(nome|seu nome)\]/i.test(text))) {
    return text || '';
  }
  const contactName =
    ctx.contactName && !looksLikePhone(ctx.contactName) ? ctx.contactName.trim() : '';
  const firstName = contactName ? contactName.split(/\s+/)[0] : '';
  const operatorName = (ctx.operatorName || '').trim();
  const now = new Date();

  let out = text
    // aliases legados do Kommo
    .replace(/\[nome\]/gi, '{{primeiro_nome}}')
    .replace(/\[seu nome\]/gi, '{{responsavel}}');

  const map = {
    nome: contactName,
    primeiro_nome: firstName,
    saudacao: saudacao(),
    data: now.toLocaleDateString('pt-BR'),
    hora: now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
  };
  if (operatorName) map.responsavel = operatorName;
  if (ctx.phone) map.telefone = ctx.phone;

  out = out.replace(/\{\{\s*([a-zA-Z_]+)\s*\}\}/g, (m, key) => {
    const k = key.toLowerCase();
    // Sem valor conhecido: mantém o marcador — o backend resolve no envio.
    return Object.prototype.hasOwnProperty.call(map, k) && map[k] !== undefined
      ? map[k]
      : m;
  });
  return tidy(out);
}

export default renderVariablesInText;
